var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHappycoinsMore = function SvgHappycoinsMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173.33,
    height: 131.593,
    viewBox: "0 0 173.33 131.593",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_666",
    x: 76.665,
    y: 53.772,
    width: 64.915,
    height: 61.915,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_238",
    "data-name": "Grupo 238",
    transform: "translate(-93.335 -96.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "raios",
    transform: "translate(94.835 98.23)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_38",
    "data-name": "Linha 38",
    y1: 29.416,
    transform: "translate(85.507 0)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_39",
    "data-name": "Linha 39",
    y1: 25.474,
    x2: 14.708,
    transform: "translate(113.336 11.581)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_40",
    "data-name": "Linha 40",
    y1: 14.708,
    x2: 25.473,
    transform: "translate(133.618 42.879)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_41",
    "data-name": "Linha 41",
    x2: 29.414,
    transform: "translate(140.916 85.507)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_42",
    "data-name": "Linha 42",
    x2: 25.474,
    y2: 14.706,
    transform: "translate(133.275 113.338)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_46",
    "data-name": "Linha 46",
    x1: 25.474,
    y2: 14.708,
    transform: "translate(11.239 112.744)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_47",
    "data-name": "Linha 47",
    x1: 29.414,
    transform: "translate(0 84.823)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_48",
    "data-name": "Linha 48",
    x1: 25.474,
    y1: 14.708,
    transform: "translate(11.581 42.287)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_49",
    "data-name": "Linha 49",
    x1: 14.707,
    y1: 25.473,
    transform: "translate(42.879 11.24)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ILUSTRA",
    transform: "translate(11.647 -68.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sombra",
    d: "M25.059,24.734c10.7,0,19.378,2.169,19.378,4.844s-8.677,4.844-19.378,4.844S5.681,32.252,5.681,29.578,14.359,24.734,25.059,24.734Z",
    transform: "translate(168.066 260.586)",
    fill: "rgba(31,26,23,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra-2",
    "data-name": "sombra",
    d: "M25.059,24.734c10.7,0,19.378,2.169,19.378,4.844s-8.677,4.844-19.378,4.844S5.681,32.252,5.681,29.578,14.359,24.734,25.059,24.734Z",
    transform: "translate(117.066 260.586)",
    fill: "rgba(31,26,23,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "estrela",
    transform: "translate(110.458 218.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666-2",
    "data-name": "Caminho 666",
    d: "M61.915,30.958A30.958,30.958,0,1,1,30.958,0,30.962,30.962,0,0,1,61.915,30.958Z",
    transform: "translate(-0.105 0.46)",
    fill: "#00a6e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_212690984",
    transform: "translate(19.895 18.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_212678000",
    d: "M33.8,16.892V22.3c0,2.25-5.143,4.075-11.486,4.075S10.825,24.55,10.825,22.3V16.892",
    transform: "translate(-10.825 -2.001)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212915960",
    d: "M33.8,14.036v5.408c0,2.25-5.143,4.075-11.486,4.075s-11.486-1.825-11.486-4.075V14.036",
    transform: "translate(-10.825 -4.553)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212685488",
    d: "M33.8,11.179v5.408c0,2.25-5.143,4.075-11.486,4.075s-11.486-1.825-11.486-4.075V11.179",
    transform: "translate(-10.825 -7.104)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212676944",
    d: "M22.311,9.027c6.342,0,11.486,1.825,11.486,4.075s-5.143,4.075-11.486,4.075S10.825,15.352,10.825,13.1s5.143-4.075,11.486-4.075Z",
    transform: "translate(-10.825 -9.027)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "estrela-2",
    "data-name": "estrela",
    transform: "translate(161.458 218.54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -79.77, -53.31)",
    filter: "url(#Caminho_666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666-3",
    "data-name": "Caminho 666",
    d: "M61.915,30.958A30.958,30.958,0,1,1,30.958,0,30.962,30.962,0,0,1,61.915,30.958Z",
    transform: "translate(79.67 53.77)",
    fill: "#00a6e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_212690984-2",
    "data-name": "_212690984",
    transform: "translate(19.895 18.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_212678000-2",
    "data-name": "_212678000",
    d: "M33.8,16.892V22.3c0,2.25-5.143,4.075-11.486,4.075S10.825,24.55,10.825,22.3V16.892",
    transform: "translate(-10.825 -2.001)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212915960-2",
    "data-name": "_212915960",
    d: "M33.8,14.036v5.408c0,2.25-5.143,4.075-11.486,4.075s-11.486-1.825-11.486-4.075V14.036",
    transform: "translate(-10.825 -4.553)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212685488-2",
    "data-name": "_212685488",
    d: "M33.8,11.179v5.408c0,2.25-5.143,4.075-11.486,4.075s-11.486-1.825-11.486-4.075V11.179",
    transform: "translate(-10.825 -7.104)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_212676944-2",
    "data-name": "_212676944",
    d: "M22.311,9.027c6.342,0,11.486,1.825,11.486,4.075s-5.143,4.075-11.486,4.075S10.825,15.352,10.825,13.1s5.143-4.075,11.486-4.075Z",
    transform: "translate(-10.825 -9.027)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHappycoinsMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/happycoins_more.cb326e30.svg";
export { ForwardRef as ReactComponent };